import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.maps.apiKey,
  },
});



// WEBPACK FOOTER //
// ./src/addons/maps.js